import { Box, Typography, Button, TextField } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';

const LeasedFiberFilterDrawer = ({
  selectedTab,
  regions,
  cities,
  rings,
  sites,
  links,
  region,
  setRegion,
  city,
  setCity,
  ring,
  setRing,
  site,
  setSite,
  link,
  setLink,
  handleRegionChange,
  handleCityChange,
  handleSiteChange,
  handleLinkChange,
  handleReset,
  handleApply,
}) => {
  // Define which filters are visible for each network type
  const visibleFilters = {
    FTTS: { region: true, city: true, ring: true, site: true, link: true },
    MPBN: { region: false, city: true, ring: false, site: true, link: true },
    OTN: { region: true, city: true, ring: false, site: true, link: true },
    IPRAN: { region: true, city: true, ring: false, site: true, link: true },
  };

  const currentFilters = visibleFilters[selectedTab] || {};

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px' }}>
      {currentFilters.region && (
        <Autocomplete
          disablePortal
          id="region"
          options={regions}
          size="small"
          value={region}
          onChange={(e, newVal) => {
            setRegion(newVal);
            setCity('');
            setRing('');
            setSite('');
            setLink('');
          }}
          sx={autocompleteStyle}
          renderInput={(params) => <TextField {...params} label="Region" />}
        />
      )}

      {currentFilters.city && (
        <Autocomplete
          disablePortal
          id="city"
          options={cities}
          size="small"
          value={city}
          onChange={(e, newVal) => {
            setCity(newVal);
            setRing('');
            setSite('');
            setLink('');
          }}
          sx={autocompleteStyle}
          renderInput={(params) => <TextField {...params} label="City" />}
        />
      )}

      {currentFilters.ring && (
        <Autocomplete
          disablePortal
          id="ring"
          options={rings}
          size="small"
          value={ring}
          onChange={(e, newVal) => setRing(newVal)}
          sx={autocompleteStyle}
          renderInput={(params) => <TextField {...params} label="Ring" />}
        />
      )}

      {currentFilters.site && (
        <Autocomplete
          disablePortal
          id="site"
          options={sites}
          size="small"
          value={site}
          onChange={(e, newVal) => setSite(newVal)}
          sx={{ ...autocompleteStyle, width: 150 }}
          renderInput={(params) => <TextField {...params} label="Site" />}
        />
      )}

      {currentFilters.link && (
        <Autocomplete
          disablePortal
          id="link"
          options={links}
          size="small"
          value={link}
          onChange={(e, newVal) => setLink(newVal)}
          sx={{ ...autocompleteStyle, width: 200 }}
          renderInput={(params) => (
            <TextField {...params} label={selectedTab === 'MPBN' ? 'Trunk' : 'Link'} />
          )}
        />
      )}

      <Button variant="contained" size="small" sx={actionButtonStyle} onClick={handleReset}>
        Reset
      </Button>

      <Button variant="contained" size="small" sx={actionButtonStyle} onClick={handleApply}>
        Apply
      </Button>
    </Box>
  );
};

const autocompleteStyle = {
  width: 130,
  backgroundColor: '#3A474F',
  borderRadius: '5px',
  color: '#fff',
  '.MuiOutlinedInput-root': {
    '& fieldset': { border: 'none' },
  },
  '.MuiAutocomplete-input': {
    color: '#fff',
    fontSize: '12px',
  },
  '.MuiAutocomplete-endAdornment': { display: 'none' },
  '.MuiInputLabel-root': { color: '#fff', fontSize: '11px' },
};

const actionButtonStyle = {
  backgroundColor: '#3A474F',
  fontSize: '11px',
  borderRadius: '5px',
  '&:hover': {
    backgroundColor: '#bd1d23',
    boxShadow: 'inset 0 0 10px #bd1d23',
  },
};

export default LeasedFiberFilterDrawer;
